import { Switch } from '@mui/material';

interface ToggleFieldProps {
  title: string;
  description: string;
  switchLabel: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
}

export default function ToggleField({
  title,
  description,
  switchLabel,
  checked,
  onChange,
}: ToggleFieldProps) {
  return (
    <div className="flex flex-col gap-1">
      <div>
        <p className="text-sm mt-0 text-primary uppercase mb-1">{title}</p>
        <p className="text-xs text-text-secondary mb-0 mt-0">{description}</p>
      </div>
      <div className="flex items-center gap-2">
        <Switch
          checked={checked}
          onChange={(e) => onChange(e.target.checked)}
          slotProps={{ input: { 'aria-label': switchLabel } }}
        />
        <span className="text-sm">{switchLabel}</span>
      </div>
    </div>
  );
}
